<script lang="ts">
	import { cookies } from '@tools';
	import { CookieNames } from '$lib/types/CookieNames';
	import { Tracker } from '@tools/tracking/Tracker';
	import { Dimensions, Events } from '@tools/tracking/Enums';

	let {
		view = $bindable('list')
	}: {
		view: 'list' | 'poster';
	} = $props();

	$effect(() => {
		Tracker.setViewmode(view === 'list' ? 'calendar' : 'poster');
	});

	function toggleView() {
		view = view === 'list' ? 'poster' : 'list';
		cookies.set(CookieNames.VIEW_MODE, view, 'functional');
		Tracker.event(Events.EVENTS_VIEW_CHANGED, {
			[Dimensions.VIEWMODE]: view === 'list' ? 'calendar' : 'poster'
		});
	}
</script>

<button
	data-component="ViewToggle"
	onclick={toggleView}
	class="button:outline no-icon"
	aria-label="Skift visning"
>
	<svg class:active={view === 'poster'} viewBox="0 0 20 20" fill="none">
		<rect x="12" y="4" width="5" height="8" />
		<path d="M3 4H8" stroke-linecap="square" />
		<path d="M17 16H11" stroke-linecap="square" />
		<rect x="3" y="8" width="5" height="8" />
	</svg>
	<svg class:active={view === 'list'} viewBox="0 0 20 20">
		<path d="M7 5H17" />
		<path d="M7 10H17" />
		<path d="M7 15H17" />
		<path d="M3 5H5" />
		<path d="M3 10H5" />
		<path d="M3 15H5" />
	</svg>
	<div class:right={view === 'list'}></div>
</button>

<style lang="scss">
	button {
		position: relative;
		overflow: hidden;
		padding-left: $gap3;
		padding-right: $gap3;
		gap: $gap4;
		background-color: $colorBackground;

		&:hover {
			background-color: $colorHover !important;
		}
	}

	svg {
		position: relative;
		z-index: 2;
		stroke: var(--background);
		height: 1.3em;
		width: 1.2em;

		&.active {
			stroke: var(--foreground);
			transition: stroke $transition;
		}
	}

	div {
		position: absolute;

		z-index: 1;
		top: 0;
		left: 0;
		width: 50%;
		height: 100%;
		background-color: $colorForeground;
		transform: translateX(0);
		transition: transform $transition;

		&.right {
			transform: translateX(100%);
		}
	}
</style>
